<template>
  <Modal
    ref="modal"
    :title="selectedTemplate.name"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="createSmsTemplate"
  >
    <TextInput label="Template Name" :model-value="sms.templateName" @update:model-value="sms.templateName = $event" />
    <TextAreaInput
      ref="contentInput"
      class="mt-4"
      label="Content"
      placeholder="Greetings from earth!"
      :model-value="sms.body"
      @update:model-value="sms.body = $event"
    />
    <SelectMenu
      class="mt-4"
      label="Merge Tags"
      initial-value="Select a merge tag..."
      :options="mergeTags"
      @selected-option="tag => $refs.contentInput.insertTextAtCursor(tag)"
    />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: ['selectedTemplate'],
  data() {
    return {
      sms: {
        templateId: this.selectedTemplate.id,
        templateName: this.selectedTemplate.name,
        body: this.selectedTemplate.body, // used exclusively to show save template button
      },
      mergeTags: [
        '{{contact.name}}',
        '{{contact.first_name}}',
        '{{contact.last_name}}',
        '{{contact.email}}',
        '{{contact.phone_number}}',
        '{{contact.source}}',
        '{{contact.referral_link}}',
        '{{team.company}}',
      ],
    };
  },
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    createSmsTemplate() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/sms_templates/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.sms.templateId,
          name: self.sms.templateName,
          body: self.sms.body,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'SMS template saved',
              alertDescription:
                'Your SMS Template was successfully saved.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'SMS template save error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
